import SeoArticlePage from '@/pages/article/SeoArticlePage';
import { reviewArticle } from '@/mocks/articles';

export default function SugargooReviewPage() {
  return <SeoArticlePage article={reviewArticle} />;
}